import Vue from "vue";

const observable = Vue.observable({
    message: "hello world",
    loginVisible : false,
    CartCount: 0,
    WishlistCount : 0,
});

export default observable;